let defaultState = {}

const settings = (state = defaultState, action) => {
  switch (action.type) {
    case 'SETTINGS_ADD':
      return {
        ...state,
        ...action.data
      }
    default:
      return state
  }
}

export default settings



// WEBPACK FOOTER //
// ./src/reducers/settings.js